import Price from '../../form/Price.react';

class ProductInformationStat extends React.Component {

    render() {
        var self = this;

        return (
            <div className='product-info__stat'>
                <div className='product-info__stat--label'>
                    {this.props.title}
                </div>
                <div className='product-info__stat--comma'>
                    :
                </div>
                <div className='product-info__stat--value'>
                    { this.props.price ?
                        <Price
                            className='product-info__stat--price'
                            price={this.props.value}
                            dollar={true} />
                        :
                        <span>{this.props.value}</span>
                    }
                </div>
            </div>
        );
    }
}

export default ProductInformationStat;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/product-information/ProductInformationStat.react.jsx